import React, { useState } from "react";
import { Link as RouterLink, useNavigate} from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios"


import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Link,
  Stack,
  TextField,
  Alert, Fade
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";

let easing = [0.6, -0.05, 0.01, 0.99];
const animate = {
  opacity: 1,
  y: 0,
  transition: {
    duration: 0.6,
    ease: easing,
    delay: 0.16,
  },
};

const SigninForm = ({ setAuth }) => {

  const url = process.env.REACT_APP_API_URL;
  const [result, setResult] = useState({severity: null, message: ""});

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Provide a valid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const navigate = useNavigate();

 

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      remember: false,
    },
    validationSchema: LoginSchema,
    onSubmit: ( values, actions ) => {

  
      console.log("submitting...");
      axios
      .post( url, values, {
        validateStatus: function (status) {
          return status < 500;  // <-- 401 bile then'e düşer
        }
      } )
      .then(response => {
            console.log('Login response data', response.data);

              setResult({message: response.data.message, severity: response.data.severity}); 

              if(response.data.code === 200){
                    setTimeout(()=>{
                        window.location.href = response.data.redirect;
                        actions.setSubmitting( false );
                    }, 1300 );
                    return;
              }
              actions.setSubmitting( false );
    
          }).catch( error => {
                setResult({message: error.message, severity: 'error'});
                actions.setSubmitting( false );
          }).finally(() => {
              console.log('Finally...');
          })
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  console.log('Formik values', result);

  return (
    <React.Fragment>
      { result?.message &&
        <Fade in={true}>
          <Alert sx={{mb:3}} severity={result.severity}>{ result.message }</Alert>
        </Fade>
      }

      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Box
              component={motion.div}
              animate={{
                transition: {
                  staggerChildren: 0.55,
                },
              }}
          >
            <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                }}
                component={motion.div}
                initial={{ opacity: 0, y: 40 }}
                animate={animate}
            >
              <TextField
                  //variant={'filled'}
                  fullWidth
                  autoComplete="username"
                  type="email"
                  label="Email Address"
                  {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
              />

              <TextField
                  fullWidth
                  autoComplete="current-password"
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  {...getFieldProps("password")}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                  InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                          >
                            {showPassword ? (
                                <Icon icon="eva:eye-fill" />
                            ) : (
                                <Icon icon="eva:eye-off-fill" />
                            )}
                          </IconButton>
                        </InputAdornment>
                    ),
                  }}
              />

            </Box>

            <Box
                component={motion.div}
                initial={{ opacity: 0, y: 20 }}
                animate={animate}
            >
              <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ my: 2 }}
              >
                <FormControlLabel
                    control={
                      <Checkbox
                          {...getFieldProps("remember")}
                          checked={values._remember_me}
                          name={'_remember_me'}
                      />
                    }
                    label="Remember me"
                />

                <Link
                    component={RouterLink}
                    variant="subtitle2"
                    to="/password-forgot"
                    underline="hover"
                >
                  Forgot password?
                </Link>
              </Stack>

              <LoadingButton
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  loading={isSubmitting}
              >
                {isSubmitting ? "loading..." : "Login"}
              </LoadingButton>

            </Box>
          </Box>
        </Form>
      </FormikProvider>
    </React.Fragment>
  );
};

export default SigninForm;
